import React, {Component} from 'react';
import './Delivery.css';
import begin7new from '../../../../../assets/img/begin7new.png';
import delivery1 from '../../../../../assets/img/delivery1.png';
import {FormattedMessage} from "react-intl";
import MetaTags from "react-meta-tags";

class Delivery extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <div className="static-pages">
                <MetaTags>
                    <title>出荷/納期｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="出荷/納期｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="出荷/納期｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">
                    <div className="row">
                        <div>
                            <p className="font-size-30 margin-div-topic">
                                <FormattedMessage id="app.delivery.shipdeliverydate"
                                                  defaultMessage="Shipping / Delivery date"
                                                  description=""
                                />
                                {/*出荷/納期*/}
                            </p>

                        </div>
                    </div>

                    <div className="row">
                        <div>
                            <p className="static-pages-headings">
                                <FormattedMessage id="app.delivery.shipment"
                                                  defaultMessage="shipment"
                                                  description=""
                                />
                                {/*出荷*/}
                            </p>
                        </div>

                        <div className="resp-image">
                            <img className="img-size" src={begin7new}/>
                        </div>

                        <div className='all-content-font-size'>
                            <p className="content-move-right">
                                <FormattedMessage id="app.delivery.boardmanufacturingcost"
                                                  defaultMessage="Imported goods are subject to Japan's customs clearance costs and domestic consumption tax, but all of these import costs are included in the board manufacturing costs."
                                                  description=""
                                />
                                {/*輸入貨物には日本側通関費用と内国消費税の対象となりますが、これらの輸入諸費用等はすべて基板製造費用に含まれております。*/}
                                <br/>
                                <FormattedMessage id="app.delivery.Sagawa"
                                                  defaultMessage="Use Sagawa Express's door-to-door Sgx service (international courier service) by utilizing Sagawa Express's home delivery transport network."
                                                  description=""
                                />
                                {/*佐川急便の宅配輸送網を生かし日本向けドアツードアの Sgx 便 ( 国際宅配便サービス ) を使用。*/}
                                <br/>
                                <FormattedMessage id="app.delivery.trackingsystem"
                                                  defaultMessage="Since the tracking results are displayed in the same way as the tracking system in Japan, it is possible to know where the package being delivered is now."
                                                  description=""
                                />
                                {/*日本国内の追跡システムと同様に追跡結果が表示されるため、配送中の荷物が今どこにあるのか分かるようになっています。*/}
                                <br/>
                                <FormattedMessage id="app.delivery.naturaldisaster"
                                                  defaultMessage="In addition, the influence by a natural disaster or a traffic accident and some remote places may be delayed from the delivery date."
                                                  description=""
                                />
                                {/*なお、天災や交通事故による影響や一部遠隔地はお届け日より遅れる場合があります。*/}
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div>
                            <p className="static-pages-headings">
                                <FormattedMessage id="app.delivery.deliverydate"
                                                  defaultMessage="Delivery date"
                                                  description=""
                                />
                                {/*納期*/}
                            </p>
                        </div>

                        <div className="div-calendar resp-image">
                            <img className="img-size" src={delivery1}/>
                        </div>

                        <div>
                            {/*<p className="content-move-right">
                            <FormattedMessage id="app.delivery.deliverydatepara1"
                                              defaultMessage="Delivery time is the time from the start of production to the completion. "
                                              description=""
                            />
                            納期は、製造開始から完了までの時間です。
                            <br/>
                            <FormattedMessage id="app.delivery.deliverydatepara2"
                                              defaultMessage="Your payment will be completed and will be counted from the next business day after the confirmation of your registered data is completed. "
                                              description=""
                            />
                            お客様の決済が完了され、ご登録いただいたデータの内容確認が完了した翌営業日からカウントされます。

                            <br/>
                            <FormattedMessage id="app.delivery.deliverydatepara3"
                                              defaultMessage="Holiday, holidays, and shipping times are not included. "
                                              description=""
                            />
                            休日、祝日、および出荷時間は含まれていません。
                            <br/>
                            <FormattedMessage id="app.delivery.deliverydatepara4"
                                              defaultMessage="If ordered on holidays and holidays, it will be processed the next business day. "
                                              description=""
                            />
                            休日と祝日に注文された場合は翌営業日に処理されます。
                            <br/>
                            <FormattedMessage id="app.delivery.deliverydatepara5"
                                              defaultMessage="Our delivery time is from 1 business day to 2 weeks depending on the manufacturing service you choose. (It varies according to the manufacturing specification and the number of sheets)"
                                              description=""
                            />
                            当社の納期は、選択した製造サービスに応じて、2 営業日から 1~2 週間です。(製造仕様・枚数により異なります)
                        </p>*/}
                            <p className="all-content-font-size all-content-line-height">
                                納期は、製造開始から完了までの時間です。<br/>
                                お客様の決済が完了され、ご登録いただいたデータの内容確認が完了した翌営業日からカウントされます。<br/>
                                休日、祝日、および出荷時間は含まれていません。<br/>
                                休日と祝日に注文された場合は翌営業日に処理されます。<br/>
                                当社の納期は、選択した製造サービスに応じて、2 営業日から 1~2 週間です。(製造仕様・枚数により異なります)

                                {/*当社の納期は、選択した製造サービスに応じて、2 営業日から 1~2<br/> 週間です。(製造仕様・枚数により異なります)*/}
                            </p>
                        </div>

                        {/*<div>*/}
                        {/*<h3>*/}

                        {/*</h3>*/}
                        {/*</div>*/}

                        <div className="content-move-right">
                            <table border="1" className="delivery-table1 all-content-font-size">
                                <tr>
                                    <td>
                                        <FormattedMessage id="app.delivery.material"
                                                          defaultMessage="Material"
                                                          description=""
                                        />
                                        {/*材質*/}
                                    </td>
                                    <td>
                                        <FormattedMessage id="app.delivery.Configuration"
                                                          defaultMessage="Layer Configuration"
                                                          description=""
                                        />

                                        {/*層構成*/}
                                    </td>
                                    <td>

                                        <FormattedMessage id="app.delivery.number"
                                                          defaultMessage="Number"
                                                          description=""
                                        />

                                        {/*枚数*/}
                                    </td>
                                    <td className="column-width">
                                        {/*<FormattedMessage id="app.delivery.productiontime"*/}
                                        {/*defaultMessage="Standard Production Time"*/}
                                        {/*description=""/>*/}
                                        {/*<br/>*/}
                                        <FormattedMessage id="app.delivery.productiontime-2"
                                                          defaultMessage="Substrate manufacturing service"
                                                          description=""/>

                                        {/*標準製造時間*/}
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan={8}>FR-4</td>
                                    <td rowSpan={2}>
                                        <FormattedMessage id="app.delivery.singleside"
                                                          defaultMessage="single-sided "
                                                          description=""
                                        />


                                        {/*片面*/}
                                    </td>
                                    <td>≦50</td>
                                    <td className="column-width">4ー 5日</td>
                                    {/*<td className="column-width">48</td>*/}
                                </tr>
                                <tr>
                                    <td>>50</td>
                                    <td className="column-width">5ー 6日</td>
                                    {/*<td className="column-width">72</td>*/}
                                </tr>
                                <tr>
                                    <td rowSpan={2}>
                                        <FormattedMessage id="app.delivery.bothside"
                                                          defaultMessage="both sides"
                                                          description=""
                                        />


                                        {/*両面*/}
                                    </td>
                                    <td>≦30</td>
                                    <td className="column-width">4ー 5日</td>
                                    {/*<td className="column-width">48</td>*/}
                                </tr>
                                <tr>
                                    <td>>30</td>
                                    <td className="column-width">6ー 7日</td>
                                    {/*<td className="column-width">72</td>*/}
                                </tr>
                                <tr>
                                    <td rowSpan={2}>
                                        <FormattedMessage id="app.delivery.4layer"
                                                          defaultMessage="4 layers"
                                                          description=""
                                        />


                                        {/*4層*/}
                                    </td>
                                    <td>≦50</td>
                                    <td className="column-width">5ー 6日</td>
                                    {/*<td className="column-width">96</td>*/}
                                </tr>
                                <tr>
                                    <td>>50</td>
                                    {/*<td className="column-width">144</td>*/}
                                    <td className="column-width">7ー 9日</td>
                                </tr>
                                <tr>
                                    <td rowSpan={2}>
                                        <FormattedMessage id="app.delivery.6layer"
                                                          defaultMessage="6 layers"
                                                          description=""
                                        />


                                        {/*6層*/}
                                    </td>
                                    <td>≦50</td>
                                    {/*<td className="column-width">96</td>*/}
                                    <td className="column-width">8ー 9日</td>
                                </tr>
                                <tr>
                                    <td>>50</td>
                                    <td className="column-width">8ー 9日</td>
                                    {/*<td className="column-width">168</td>*/}
                                </tr>
                            </table>
                        </div>
                        <br/>

                        <div className='all-content-font-size'>
                            <p className="content-move-right">
                                <FormattedMessage id="app.delivery.stdproductiontime"
                                                  defaultMessage="※ The above is standard production time. "
                                                  description=""
                                />


                                {/*※上記は標準製造時間です。*/}
                                <br/>

                                <FormattedMessage id="app.delivery.delivarydate"
                                                  defaultMessage="※ Please use the standard production time +72 hours as a guide for the delivery date."
                                                  description=""
                                />


                                {/*※お届け予定日は標準製造時間 +48 時間を目安にして下さい。*/}
                            </p>
                        </div>
                    </div>
                    {/*<br/>*/}

                    <div className="row">
                        <div>
                            <p className="static-pages-headings">
                                <FormattedMessage id="app.delivery.indication"
                                                  defaultMessage="An indication of the movable day of metal mask manufacturing service"
                                                  description=""
                                />


                                {/*メタルマスク製造サービスの可動日の目安*/}
                            </p>
                        </div>
                        <br/>
                        <div className="content-move-right all-content-font-size">
                            <table border="1" className="delivery-table2 delivery-table1 all-content-font-size">
                                <tr>
                                    <td>
                                        <FormattedMessage id="app.delivery.material2"
                                                          defaultMessage="Material"
                                                          description=""
                                        />


                                        {/*材質*/}
                                    </td>
                                    <td>
                                        <FormattedMessage id="app.delivery.Specification"
                                                          defaultMessage="Specification"
                                                          description=""
                                        />


                                        {/*仕様*/}
                                    </td>
                                    <td>
                                        <FormattedMessage id="app.delivery.stdtime"
                                                          defaultMessage="Standard Production Time"
                                                          description=""
                                        />


                                        {/*標準製造時間*/}
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan={2}>
                                        <FormattedMessage id="app.delivery.susmaterial"
                                                          defaultMessage="SUS material (t0.12)"
                                                          description=""
                                        />
                                        {/*SUS 材(t0.12)*/}
                                    </td>
                                    <td>
                                        <FormattedMessage id="app.delivery.withframe"
                                                          defaultMessage="With frame "
                                                          description=""
                                        />


                                        {/*フレーム有り*/}
                                        <br/>
                                        <FormattedMessage id="app.delivery.allsize"
                                                          defaultMessage="All sizes"
                                                          description=""
                                        />


                                        {/*※全サイズ*/}
                                    </td>
                                    <td>5ー8日</td>
                                    {/*<td>48</td>*/}
                                </tr>
                                <tr>
                                    <td>
                                        <FormattedMessage id="app.delivery.noframe"
                                                          defaultMessage="No frame"
                                                          description=""
                                        />


                                        {/*フレーム無し*/}
                                        <br/>
                                        <FormattedMessage id="app.delivery.allsize2"
                                                          defaultMessage="All sizes"
                                                          description=""
                                        />


                                        {/*※全サイズ*/}
                                    </td>
                                    <td>5ー8日</td>
                                    {/*<td>48</td>*/}
                                </tr>
                            </table>
                        </div>
                        <br/>
                        {/*<br/>*/}
                        <div>
                            {/* <p className="content-move-right">
                            <FormattedMessage id="app.delivery.thickness"
                                              defaultMessage="※ The standard thickness of the metal mask is 0.12 mm."
                                              description=""
                            />
                            ※メタルマスクの標準の厚さは 0.12mm です。
                            <br/>
                            <FormattedMessage id="app.delivery.stdprodtime"
                                              defaultMessage="※ The above is standard production time."
                                              description=""
                            />
                            ※上記は標準製造時間です。
                            <br/>
                            <FormattedMessage id="app.delivery.guidedeliverdate"
                                              defaultMessage="※ Please use the standard production time 72 hours as a guide for the delivery date."
                                              description=""
                            />
                            ※お届け予定日は標準製造時間 72 時間を目安にして下さい。
                        </p>*/}
                            <p className="all-content-font-size">
                                ※メタルマスクの標準の厚さは 0.12mm です。 <br/>&nbsp;&nbsp; 0.12mm以外の厚さをご希望の場合は、ご相談ください。<br/>
                                ※上記は標準製造時間です。<br/>
                                ※お届け予定日は標準製造時間に＋3日を目安にして下さい。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Delivery;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Delivery.js